import "./Services.css";
import { useT } from "@/i18n/context";

const ICONS = [
  "M12 2a5 5 0 0 1 5 5v1a5 5 0 0 1-1 9 4 4 0 0 1-8 0 5 5 0 0 1-1-9V7a5 5 0 0 1 5-5Z",
  "M7 18a4 4 0 0 1 0-8 6 6 0 0 1 11.5 2A3.5 3.5 0 0 1 18 18H7Z",
  "M4 20V10m5 10V4m5 16v-7m5 7V8",
  "M12 3v3m0 12v3m9-9h-3M6 12H3m13.5-6.5-2 2m-7 7-2 2m11 0-2-2m-7-7-2-2",
  "M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6l7-3Z",
];

export function Services() {
  const t = useT();
  return (
    <section id="services" className="section section--alt services">
      <div className="container">
        <h2 className="section__heading">{t.services.heading}</h2>
        <div className="services__grid" data-reveal="">
          {t.services.items.map((item, i) => (
            <article key={item.title} className="service-item">
              <svg
                className="service-item__icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d={ICONS[i] ?? ICONS[0]} />
              </svg>
              <h3 className="service-item__title">{item.title}</h3>
              <p className="service-item__desc">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
